export const transmitters = {
    'emitters': {
        /* When user joins socket for first time */
        'manual-connection': 'manualConnection',

        /* Admin emitter, to wake customer with query data */
        'wake-user-for-support-chat': 'wakeUserForSupportChat',

        /* Admin emitter,  to customer for ending chat from both sides */
        'force-close-chat-action': 'forceCloseChatAction',
    },

    'listeners': {
        /* Customer listeners, that chat is coming from admin side with query data  */
        'support-chat-call': 'supportChatCall',

        /* Customer listener, that admin wants to end chat */
        'force-close-chat-user': 'forceCloseChatUser'
    }
}